import { Layout } from 'antd';
import styled from 'styled-components';

export default styled(Layout)``;
